module.exports = __webpack_public_path__ + "static/media/logo1.f9f2e43d.png";